export default __webpack_public_path__ + "static/media/backyard.ca76e831.jpg";